export const styles = {
    typography: {
        lineHeight: 1.8
    },
    bolder: {
        fontWeight: 500
    }
};
